import $ from "jquery";
import { Klass, csl, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import renderCalendar from "./renderCalendar";

/**************************************
* define Klass VuwMinimalCalendarBody *
**************************************/
vuwer.appendKlass("VuwMinimalCalendarBody", {
	classPrefix: "",
	weekdaysKeys: null,
	weekdaysTexts: null,
	firstDayOfWeek: 0,
	onRenderDay($day, dataAttr, eventsOfDay) {},
	onEventClick($event, data) {},
	...renderCalendar,
	
	_initialize(opt) {
		const _super_ = Klass("VuwMinimalCalendarBody").parent._initialize.bind(this);
		if( !_super_(opt) ) {
			return false;
		}
		
		if( !Array.isArray(this.weekdaysKeys) ) {
			csl.warn("VuwMinimalCalendarBody is require {array} `weekdaysKeys`.");
			return false;
		}
		
		if( !Array.isArray(this.weekdaysTexts) ) {
			csl.warn("VuwMinimalCalendarBody is require {array} `weekdaysTexts`.");
			return false;
		}
		
		// [add onReady callback]
		this._onReadyCallbacks.unshift(this._onReadyDefault);
		
		// [add onChangeState callback]
		this._onChangeStateCallbacks.unshift(this._onChangeStateDefault);
		
		return this;
	},
	
	selector() {
		if(this.container && this.container.$self) {
			return $("<div/>").addClass(
				`${this.classPrefix}body ${this.classPrefix}table`
			).appendTo(
				this.container.$self
			);
		}
	},
	
	_onReadyDefault($self) {
		if(!$self) {
			return false;
		}
		
		const $weekTemplate = $("<li/>").addClass(`${this.classPrefix}week`);
		this.setProp({ $weekTemplate });
		
		// [create thead]
		this.$thead = $("<ul/>").addClass(`${this.classPrefix}thead`).append(
			$.fn.append.apply(
				$weekTemplate.clone(),
				this.weekdaysTexts.map((w, i) => $("<div/>").addClass(
					`${this.classPrefix}day`
				).attr({ "data-weekday": this.weekdaysKeys[i] }).text(w))
			)
		).appendTo($self);
		
		// [create tbody]
		this.$tbody = this.createTbody().appendTo($self);
		
		// add event listeners.
		$self
		.on("click", `.${this.classPrefix}has-events`, e => {
			e.preventDefault();
			$(e.currentTarget).toggleClass("is-active");
		})
		.on( "click", `.${this.classPrefix}event-item`, e => {
			e.preventDefault();
			if( u_.isFunction(this.onEventClick) ) {
				const $event = $(e.currentTarget);
				return this.onEventClick.call( e.currentTarget, $event, $event.data("item") );
			}
		});
	},
	
	_onChangeStateDefault(state) {
		if(state.ym) {
			this.renderCalendar(state.ym, state.holidays, state.events);
		}
	},
	
	createTbody() {
		return $("<ul/>").addClass(`${this.classPrefix}tbody`);
	}
});
